export const normalize = value => (typeof value === 'string' ? value.trim() : value);

export const normalizeKey = value => (typeof value === 'string' ? value.trim().toLowerCase() : value);
